import ControlList from "slotworks/smart-ui/control-list";
import AutoplaySpinButtonRingControl from "./autoplay-spin-button-ring-control";
import GoldenRockSpinControl from "./golden-rock-spin-button-control";

export default class GoldenRockControlList {

    // This picks up the autoplay counts, but it won't do freespins - see goldenrockbetbarcomponent
    public static AUTOPLAY_SPIN_BUTTON_RING = new ControlList<AutoplaySpinButtonRingControl>(AutoplaySpinButtonRingControl, "spin_button_ring");
    public static GOLDEN_ROCK_SPIN = new ControlList<GoldenRockSpinControl>(GoldenRockSpinControl, "golden_rock_spin_button");

    public static init() {
        ControlList.addControlList(GoldenRockControlList.AUTOPLAY_SPIN_BUTTON_RING);
        ControlList.addControlList(GoldenRockControlList.GOLDEN_ROCK_SPIN);
    }

}
